export const translations = {
  en: {
    // Navigation
    nav: {
      business: "Business",
      weddings: "Weddings",
      portfolio: "Portfolio",
      process: "Process",
      contact: "Contact"
    },

    // Hero Section
    hero: {
      badge: "FOTO · VIDEO · FILM",
      headline: "Visual stories that move.",
      subheadline: "Authentic visual content for businesses and the most beautiful day of your life.",
      cta: {
        primary: "Start a project",
        secondary: "View Portfolio"
      },
      card: {
        business: {
          title: "For Businesses",
          body: "Image films, events, social media content and professional business photography",
          link: "Learn more"
        },
        weddings: {
          title: "For Weddings",
          body: "Emotional wedding photography and cinematic wedding films for timeless memories",
          link: "Learn more"
        }
      }
    },

    // About / Identity Section
    about: {
      label: "WHO WE ARE",
      headline: "Two people. One camera. Your story.",
      body: "We are a creative duo combining emotional storytelling with professional visual language – for businesses that want to be more than a brand, and for couples who want to hold on to their day forever.",
      col1: {
        title: "Photography",
        body: "Professional visual language that captures emotions and tells stories"
      },
      col2: {
        title: "Video Production",
        body: "Cinematic storytelling for moving moments and authentic brand films"
      },
      col3: {
        title: "Premium Quality",
        body: "State-of-the-art equipment and years of experience for first-class results"
      }
    },

    // Team / Duo Section
    team: {
      label: "THE DUO",
      headline: "Personal. Professional. Passionate.",
      body: "We believe the best images are created where trust and creativity meet. As a duo, we don't just bring two cameras – we bring two perspectives that together tell one story.",
      cta: "Get to know us",
      role: {
        photographer: "Photographer",
        videographer: "Video & Photographer"
      }
    },

    // Business Section
    business: {
      label: "BUSINESS & COMMERCIAL",
      headline: "Professional productions for your company.",
      body: "We create high-quality visual content that presents your brand authentically and makes a lasting impression on your target audience.",
      services: {
        s1: {
          title: "Image Films",
          body: "Professional corporate films that present your brand authentically"
        },
        s2: {
          title: "Event Coverage",
          body: "Photo and video documentation of your business events and conferences"
        },
        s3: {
          title: "Social Media Content",
          body: "High-quality content for your digital channels and campaigns"
        },
        s4: {
          title: "Branding Photography",
          body: "Visual language that makes your brand identity tangible"
        },
        s5: {
          title: "Recruiting Content",
          body: "Authentic employer branding content for talent acquisition"
        },
        s6: {
          title: "Corporate Portraits",
          body: "Professional portraits of your team and leadership"
        }
      },
      cta: "Request a Business Project"
    },

    // Wedding Section
    wedding: {
      label: "WEDDINGS & COUPLES",
      headline: "Timeless memories of your most beautiful day.",
      body: "Emotional wedding photography and cinematic wedding films that capture the unique moments of your wedding for eternity.",
      services: {
        s1: {
          title: "Wedding Photography",
          body: "Emotional, timeless images of your most beautiful day"
        },
        s2: {
          title: "Wedding Film",
          body: "Cinematic storytelling – your wedding day as a moving film"
        },
        s3: {
          title: "Full-Day Coverage",
          body: "From preparations to the party – we're there all day"
        },
        s4: {
          title: "Couple Sessions",
          body: "Intimate couple shoots before or after the wedding"
        },
        s5: {
          title: "Destination Weddings",
          body: "We accompany you to your dream wedding – worldwide"
        },
        s6: {
          title: "After-Wedding Shoot",
          body: "Relaxed shoot after the wedding in a stunning location"
        }
      },
      cta: "Inquire About Your Wedding"
    },

    // Portfolio Section
    portfolio: {
      label: "OUR WORK",
      headline: "Selected Works",
      body: "A glimpse into our recent projects – from emotional wedding stories to professional business productions",
      filter: {
        all: "ALL PROJECTS",
        business: "BUSINESS",
        weddings: "WEDDINGS"
      },
      watchFilm: "▷ Watch Film",
      viewGallery: "View Gallery →",
      viewInstagram: "View Instagram Channel",
      year: "Year",
      services: "Services",
      cta: "Discuss a project"
    },

    // Why Choose Us Section
    whyChooseUs: {
      headline: "Why work with CIFT Studio?",
      body: "We combine technical excellence with creative storytelling. Our goal is to create authentic and aesthetic content that touches emotionally and impresses sustainably.",
      features: {
        f1: {
          title: "Professional Equipment",
          body: "State-of-the-art camera and lighting technology for the highest quality"
        },
        f2: {
          title: "Experienced Team",
          body: "Years of expertise in photography and video production"
        },
        f3: {
          title: "Authentic Visual Language",
          body: "Natural, emotional shots instead of staged poses"
        },
        f4: {
          title: "Reliable Communication",
          body: "Clear agreements and transparent collaboration"
        },
        f5: {
          title: "Creative Implementation",
          body: "Individual concepts that tell your story"
        },
        f6: {
          title: "On-Time Delivery",
          body: "Punctual delivery of your finished shots"
        }
      }
    },

    // Process Section
    process: {
      label: "HOW IT WORKS",
      headline: "How our collaboration works",
      body: "From the first contact to the delivery of your finished shots – we accompany you professionally through every step",
      steps: {
        step1: {
          title: "Inquiry",
          body: "You contact us via the form or directly by email/phone"
        },
        step2: {
          title: "Initial Consultation",
          body: "We get to know each other and discuss your ideas and wishes"
        },
        step3: {
          title: "Concept & Planning",
          body: "Together we develop the perfect concept for your project"
        },
        step4: {
          title: "Production",
          body: "We implement your project professionally and creatively"
        },
        step5: {
          title: "Editing",
          body: "Careful selection and professional post-processing of your recordings"
        },
        step6: {
          title: "Delivery",
          body: "You receive your finished photos and videos in the best quality"
        }
      },
      ctaBox: {
        headline: "Ready to start your project?",
        body: "Contact us for a free initial consultation and let us realize your vision together.",
        cta: "Get in touch now"
      }
    },

    // Testimonials Section
    testimonials: {
      headline: "What our clients say",
      body: "Trust the experiences of our satisfied clients",
      trustText: "Trusted by leading companies and over 100 happy wedding couples"
    },

    // FAQ Section
    faq: {
      headline: "Frequently Asked Questions",
      body: "Here you will find answers to the most important questions. For further inquiries, please contact us directly.",
      questions: {
        q1: {
          question: "How does a booking work?",
          answer: "After your inquiry, we arrange a free initial consultation (by phone or in person) where we discuss your ideas. You will then receive an individual offer. After confirmation and down payment, your date is firmly reserved."
        },
        q2: {
          question: "What about pricing?",
          answer: "Our prices depend on the type and scope of the project. For weddings, we offer various packages. We calculate business projects individually. Contact us for a non-binding quote."
        },
        q3: {
          question: "How long does editing take?",
          answer: "You typically receive photos within 3-4 weeks after the event. We deliver wedding films after 6-8 weeks. For express editing, please contact us – faster delivery is also possible for an additional fee."
        },
        q4: {
          question: "In which regions are you active?",
          answer: "Our headquarters is in the Stuttgart region, but we are bookable throughout Germany and internationally. For destination weddings and supra-regional business projects, we are happy to create individual offers including travel."
        },
        q5: {
          question: "Do you offer photo and video combined?",
          answer: "Yes, absolutely! We even recommend the combination of photo and video for a holistic result. Our packages can be flexibly combined, or we bring a complete team."
        },
        q6: {
          question: "Can we express individual wishes?",
          answer: "Of course! Every project is unique. We adapt to your ideas, your style and your requirements. In the preliminary discussion, we clarify all details and develop a tailor-made concept together."
        }
      },
      ctaText: "Have more questions?",
      ctaButton: "Get personal advice"
    },

    // Contact Section
    contact: {
      label: "GET IN TOUCH",
      headline: "Let's talk",
      body: "Ready for your next project? Contact us for a non-binding initial consultation.",
      info: {
        headline: "Contact Information",
        email: "Email",
        instagram: "Instagram",
        website: "Website",
        quickResponse: "Quick response guaranteed",
        quickResponseText: "We usually respond within 24 hours. For urgent inquiries, you can also reach us directly by email."
      },
      form: {
        name: "Your Name",
        email: "Email",
        phone: "Phone (optional)",
        projectType: "Type of Inquiry",
        projectTypes: {
          business: "Business / Commercial Inquiry",
          wedding: "Wedding Inquiry",
          other: "Other"
        },
        message: "Your Message",
        messagePlaceholder: "Tell us about your project...",
        submit: "Send inquiry",
        sending: "Sending...",
        privacy: "By submitting you accept our privacy policy",
        success: "Inquiry sent!",
        successMessage: "We will get back to you as soon as possible. Thank you for your interest!"
      }
    },

    // Footer
    footer: {
      about: "High-quality photo and video productions for businesses and weddings.",
      services: "Services",
      information: "Information",
      copyright: "© 2025 CIFT Studio. All rights reserved.",
      legal: {
        imprint: "Imprint",
        privacy: "Privacy",
        terms: "Terms"
      }
    }
  },

  de: {
    // Navigation
    nav: {
      business: "Business",
      weddings: "Hochzeiten",
      portfolio: "Portfolio",
      process: "Ablauf",
      contact: "Kontakt"
    },

    // Hero Section
    hero: {
      badge: "FOTO · VIDEO · FILM",
      headline: "Visuelle Geschichten, die bewegen.",
      subheadline: "Authentische visuelle Inhalte für Unternehmen und das schönste Datum eures Lebens.",
      cta: {
        primary: "Projekt anfragen",
        secondary: "Portfolio ansehen"
      },
      card: {
        business: {
          title: "Für Unternehmen",
          body: "Imagefilme, Events, Social Media Content und professionelle Business-Fotografie",
          link: "Mehr erfahren"
        },
        weddings: {
          title: "Für Hochzeiten",
          body: "Emotionale Hochzeitsfotografie und cinematic Hochzeitsfilme für zeitlose Erinnerungen",
          link: "Mehr erfahren"
        }
      }
    },

    // About / Identity Section
    about: {
      label: "WER WIR SIND",
      headline: "Zwei Menschen. Eine Kamera. Eure Geschichte.",
      body: "Wir sind Tuba und Mustafa, ein Duo aus Leidenschaft und Präzision. Gemeinsam verbinden wir emotionales Storytelling mit professioneller Bildsprache – für Unternehmen, die mehr sein wollen als eine Marke, und für Paare, die ihren Tag für immer festhalten möchten.",
      col1: {
        title: "Fotografie",
        body: "Professionelle Bildsprache, die Emotionen einfängt und Geschichten erzählt"
      },
      col2: {
        title: "Videoproduktion",
        body: "Cinematic Storytelling für bewegende Momente und authentische Markenfilme"
      },
      col3: {
        title: "Premium Qualität",
        body: "Modernste Technik und langjährige Erfahrung für erstklassige Ergebnisse"
      }
    },

    // Team / Duo Section
    team: {
      label: "DAS DUO",
      headline: "Persönlich. Professionell. Leidenschaftlich.",
      body: "Wir glauben, dass die besten Bilder dort entstehen, wo Vertrauen und Kreativität aufeinandertreffen. Als Duo bringen wir nicht nur zwei Kameras – wir bringen zwei Perspektiven, die zusammen eine Geschichte erzählen.",
      cta: "Uns kennenlernen",
      role: {
        photographer: "Fotografin",
        videographer: "Video- und Fotograf"
      }
    },

    // Business Section
    business: {
      label: "BUSINESS & COMMERCIAL",
      headline: "Professionelle Produktionen für Ihr Unternehmen.",
      body: "Wir entwickeln hochwertige visuelle Inhalte, die Ihre Marke authentisch präsentieren und Ihre Zielgruppe nachhaltig beeindrucken.",
      services: {
        s1: {
          title: "Imagefilme",
          body: "Professionelle Unternehmensfilme, die Ihre Marke authentisch präsentieren"
        },
        s2: {
          title: "Eventbegleitung",
          body: "Foto- und Videodokumentation Ihrer Business-Events und Konferenzen"
        },
        s3: {
          title: "Social Media Content",
          body: "Hochwertiger Content für Ihre digitalen Kanäle und Kampagnen"
        },
        s4: {
          title: "Branding-Fotografie",
          body: "Bildsprache, die Ihre Markenidentität visuell erlebbar macht"
        },
        s5: {
          title: "Recruiting Content",
          body: "Authentischer Employer-Branding-Content für Ihre Talentgewinnung"
        },
        s6: {
          title: "Unternehmensportraits",
          body: "Professionelle Portraits Ihres Teams und Ihrer Führungskräfte"
        }
      },
      cta: "Business-Anfrage stellen"
    },

    // Wedding Section
    wedding: {
      label: "HOCHZEIT & PAARE",
      headline: "Zeitlose Erinnerungen für Ihren schönsten Tag.",
      body: "Emotionale Hochzeitsfotografie und cinematic Hochzeitsfilme, die die einzigartigen Momente Ihrer Hochzeit für die Ewigkeit festhalten.",
      services: {
        s1: {
          title: "Hochzeitsfotografie",
          body: "Emotionale, zeitlose Bilder Ihres schönsten Tages"
        },
        s2: {
          title: "Hochzeitsfilm",
          body: "Cinematic Storytelling – Ihr Hochzeitstag als bewegender Film"
        },
        s3: {
          title: "Ganztagesbegleitung",
          body: "Von den Vorbereitungen bis zur Party – wir sind den ganzen Tag dabei"
        },
        s4: {
          title: "Couple Sessions",
          body: "Intime Paarshootings vor oder nach der Hochzeit"
        },
        s5: {
          title: "Destination Weddings",
          body: "Wir begleiten Sie zu Ihrer Traumhochzeit – weltweit"
        },
        s6: {
          title: "After-Wedding-Shooting",
          body: "Entspanntes Shooting nach der Hochzeit in traumhafter Location"
        }
      },
      cta: "Hochzeit anfragen"
    },

    // Portfolio Section
    portfolio: {
      label: "AUSGEWÄHLTE ARBEITEN",
      headline: "Ausgewählte Arbeiten",
      body: "Ein Einblick in unsere jüngsten Projekte – von emotionalen Hochzeitsgeschichten bis zu professionellen Business-Produktionen",
      filter: {
        all: "ALLE PROJEKTE",
        business: "BUSINESS",
        weddings: "HOCHZEITEN"
      },
      watchFilm: "▷ Film ansehen",
      viewGallery: "Galerie ansehen →",
      viewInstagram: "Zum Instagram-Kanal",
      year: "Jahr",
      services: "Leistungen",
      cta: "Projekt besprechen"
    },

    // Why Choose Us Section
    whyChooseUs: {
      headline: "Warum mit CIFT Studio arbeiten?",
      body: "Wir verbinden technische Exzellenz mit kreativem Storytelling. Unser Ziel ist es, authentische und ästhetische Inhalte zu schaffen, die emotional berühren und nachhaltig beeindrucken.",
      features: {
        f1: {
          title: "Professionelle Ausstattung",
          body: "Modernste Kamera- und Lichttechnik für höchste Qualität"
        },
        f2: {
          title: "Erfahrenes Team",
          body: "Langjährige Expertise in Foto- und Videoproduktion"
        },
        f3: {
          title: "Authentische Bildsprache",
          body: "Natürliche, emotionale Aufnahmen statt gestellter Posen"
        },
        f4: {
          title: "Zuverlässige Kommunikation",
          body: "Klare Absprachen und transparente Zusammenarbeit"
        },
        f5: {
          title: "Kreative Umsetzung",
          body: "Individuelle Konzepte, die Ihre Geschichte erzählen"
        },
        f6: {
          title: "Termingerechte Lieferung",
          body: "Pünktliche Übergabe Ihrer fertigen Aufnahmen"
        }
      }
    },

    // Process Section
    process: {
      label: "WIE ES FUNKTIONIERT",
      headline: "So läuft die Zusammenarbeit ab",
      body: "Von der ersten Kontaktaufnahme bis zur Übergabe Ihrer fertigen Aufnahmen – wir begleiten Sie professionell durch jeden Schritt",
      steps: {
        step1: {
          title: "Anfrage",
          body: "Sie kontaktieren uns über das Formular oder direkt per E-Mail/Telefon"
        },
        step2: {
          title: "Erstgespräch",
          body: "Wir lernen uns kennen und besprechen Ihre Vorstellungen und Wünsche"
        },
        step3: {
          title: "Konzept & Planung",
          body: "Gemeinsam entwickeln wir das perfekte Konzept für Ihr Projekt"
        },
        step4: {
          title: "Produktion",
          body: "Wir setzen Ihr Projekt professionell und kreativ um"
        },
        step5: {
          title: "Bearbeitung",
          body: "Sorgfältige Auswahl und professionelle Nachbearbeitung Ihrer Aufnahmen"
        },
        step6: {
          title: "Übergabe",
          body: "Sie erhalten Ihre fertigen Fotos und Videos in bester Qualität"
        }
      },
      ctaBox: {
        headline: "Bereit, Ihr Projekt zu starten?",
        body: "Kontaktieren Sie uns für ein kostenloses Erstgespräch und lassen Sie uns gemeinsam Ihre Vision verwirklichen.",
        cta: "Jetzt Kontakt aufnehmen"
      }
    },

    // Testimonials Section
    testimonials: {
      headline: "Was unsere Kunden sagen",
      body: "Vertrauen Sie auf die Erfahrungen unserer zufriedenen Kunden",
      trustText: "Vertraut von führenden Unternehmen und über 100 glücklichen Hochzeitspaaren"
    },

    // FAQ Section
    faq: {
      headline: "Häufig gestellte Fragen",
      body: "Hier finden Sie Antworten auf die wichtigsten Fragen. Bei weiteren Anliegen kontaktieren Sie uns gerne direkt.",
      questions: {
        q1: {
          question: "Wie läuft eine Buchung ab?",
          answer: "Nach Ihrer Anfrage vereinbaren wir ein kostenloses Erstgespräch (telefonisch oder persönlich), in dem wir Ihre Vorstellungen besprechen. Anschließend erhalten Sie ein individuelles Angebot. Nach Bestätigung und Anzahlung ist Ihr Termin fest reserviert."
        },
        q2: {
          question: "Wie gestalten sich die Preise?",
          answer: "Unsere Preise richten sich nach Art und Umfang des Projekts. Für Hochzeiten bieten wir verschiedene Pakete an. Business-Projekte kalkulieren wir individuell. Kontaktieren Sie uns für ein unverbindliches Angebot."
        },
        q3: {
          question: "Wie lange dauert die Bearbeitung?",
          answer: "Fotos erhalten Sie in der Regel innerhalb von 3-4 Wochen nach dem Event. Hochzeitsfilme liefern wir nach 6-8 Wochen. Für Express-Bearbeitungen sprechen Sie uns an – gegen Aufpreis ist auch eine schnellere Übergabe möglich."
        },
        q4: {
          question: "In welchen Regionen seid ihr tätig?",
          answer: "Unser Hauptsitz ist in der Region Stuttgart, wir sind jedoch deutschlandweit und international buchbar. Für Destination Weddings und überregionale Business-Projekte erstellen wir gerne individuelle Angebote inklusive Anfahrt."
        },
        q5: {
          question: "Bietet ihr Foto und Video kombiniert an?",
          answer: "Ja, absolut! Wir empfehlen sogar die Kombination aus Foto und Video für ein ganzheitliches Ergebnis. Unsere Pakete können flexibel kombiniert werden, oder wir bringen ein komplettes Team mit."
        },
        q6: {
          question: "Können wir individuelle Wünsche äußern?",
          answer: "Selbstverständlich! Jedes Projekt ist einzigartig. Wir passen uns Ihren Vorstellungen, Ihrem Stil und Ihren Anforderungen an. Im Vorgespräch klären wir alle Details und entwickeln gemeinsam ein maßgeschneidertes Konzept."
        }
      },
      ctaText: "Haben Sie weitere Fragen?",
      ctaButton: "Persönlich beraten lassen"
    },

    // Contact Section
    contact: {
      label: "KONTAKT",
      headline: "Lassen Sie uns sprechen",
      body: "Bereit für Ihr nächstes Projekt? Kontaktieren Sie uns für ein unverbindliches Erstgespräch.",
      info: {
        headline: "Kontaktinformationen",
        email: "E-Mail",
        instagram: "Instagram",
        website: "Website",
        quickResponse: "Schnelle Antwort garantiert",
        quickResponseText: "Wir antworten in der Regel innerhalb von 24 Stunden. Für dringende Anfragen erreichen Sie uns auch direkt per E-Mail."
      },
      form: {
        name: "Ihr Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        projectType: "Art der Anfrage",
        projectTypes: {
          business: "Business / Commercial Anfrage",
          wedding: "Hochzeits-Anfrage",
          other: "Sonstiges"
        },
        message: "Ihre Nachricht",
        messagePlaceholder: "Erzählen Sie uns von Ihrem Projekt...",
        submit: "Anfrage senden",
        sending: "Senden...",
        privacy: "Mit dem Absenden akzeptieren Sie unsere Datenschutzbestimmungen",
        success: "Anfrage gesendet!",
        successMessage: "Wir melden uns schnellstmöglich bei Ihnen. Vielen Dank für Ihr Interesse!"
      }
    },

    // Footer
    footer: {
      about: "Hochwertige Foto- und Videoproduktionen für Unternehmen und Hochzeiten.",
      services: "Leistungen",
      information: "Informationen",
      copyright: "© 2025 CIFT Studio. Alle Rechte vorbehalten.",
      legal: {
        imprint: "Impressum",
        privacy: "Datenschutz",
        terms: "AGB"
      }
    }
  }
};
